// client-web-appsuite/src/constants/balance.js

let BALANCE = Object.freeze({
    DEFAULT: 0.5
})

export default BALANCE